import React from 'react';

const BookingPage: React.FC = () => {
    return (
        <div>
            <h1>Book your stay</h1>
        </div>
    );
};

export default BookingPage;
